module.exports = __webpack_public_path__ + "media/cha-tea.caa1276c.mp3";